<template>
  <div class="ma-4 px-4">
    <searchBarFilter
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      :showProgramFilter="true"
      @updateProgram="(v) => (programFilter = v)"
      @batchFilter="(v) => (yearFilter = v)"
      :showBatchFilter="true"
      :programs="programs"
      :downloadButton="true"
      :downloadUrl="'download_batch_scheme'"
      headerText="Batch Scheme"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="filteredBatchSchemes"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.download`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="download(item)">
                mdi-download
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createBatchScheme"
        @update="updateBatchScheme"
        :programs="programs"
        :batch_scheme="batch_scheme"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/scheme/batch_scheme.vue";
import searchBarFilter from "@/components/searchBarFilter.vue";
import { batchSchemeHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBarFilter,
  },
  data() {
    return {
      headers: batchSchemeHeaders,
      dialog: false,
      editMode: false,
      search: "",
      programFilter: null,
      yearFilter: null,
      batch_schemes: [],
      programs: [],
      batch_scheme: {},
    };
  },
  watch: {},
  computed: {
    filteredBatchSchemes() {
      return this.batch_schemes.filter((item) => {
        const matchesProgram =
          !this.programFilter ||
          this.normalize(item.program_batch_name) ===
            this.normalize(this.programFilter);
        const matchesYear =
          !this.yearFilter || item.batch === this.yearFilter;
        return matchesProgram && matchesYear;
      });
    },
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Batch Schemes" }]);
    this.initialise();
  },
  methods: {
    normalize(value) {
      return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
    },
    async initialise() {
      const [batch_schemes, programs] = await Promise.all([
        this.$axios.get("batch_schemes"),
        this.$axios.get("programs"),
      ]);
      const batchList = batch_schemes.data.data;
      this.batch_schemes = batchList.sort((a, b) => b.id - a.id);
      this.programs = programs.data.data;
    },
    async createBatchScheme(data) {
      await this.$axios
        .post("batch_schemes", { batch_scheme: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch Scheme created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateBatchScheme(data) {
      await this.$axios
        .put("batch_schemes/" + data.id, { batch_scheme: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch Scheme updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    edit(item) {
      this.batch_scheme = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.batch_scheme = {};
    },
    async download(item) {
      this.$axios
        .get(`/download_batch_scheme`, {
          responseType: "blob",
          params: { id: item.id },
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Batch Scheme.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>

<style></style>
